import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { SECTIONS } from '../data/profile';
type SectionNavProps = {
  currentIndex: string;
};
export function SectionNav({
  currentIndex
}: SectionNavProps) {
  const position = SECTIONS.findIndex(s => s.index === currentIndex);
  const previous = position > 0 ? SECTIONS[position - 1] : null;
  const next = position < SECTIONS.length - 1 ? SECTIONS[position + 1] : null;
  return <nav aria-label="Section pagination" className="w-full border-t border-slateink-300/60 bg-slateink-100" data-id="element-288" data-mp="1gsljqqdsb7dg">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-px bg-slateink-300/70 px-0 sm:grid-cols-2" data-id="element-289" data-mp="1c0lcecvdxc6u">
        {previous ? <Link to={previous.to} className="group flex items-center gap-4 bg-slateink-100 px-6 py-8 transition-colors hover:bg-white lg:px-8" data-id="element-290" data-mp="172a5a9wh5fsb">
            <ArrowLeftIcon className="h-4 w-4 flex-none text-gold-600 transition-transform group-hover:-translate-x-1" aria-hidden="true" data-id="element-291" data-mp="1zqfqsyvcr8t7" />
            <span data-id="element-292" data-mp="1766yawyhmb8h">
              <span className="block text-[10px] uppercase tracking-widest text-slateink-500" data-id="element-293" data-mp="175fai8b4thsr">
                Previous · Section {previous.index}
              </span>
              <span className="mt-1.5 block font-serif text-base text-navy-900" data-id="element-294" data-mp="xfm21g6adisq">
                {previous.label}
              </span>
            </span>
          </Link> : <span className="hidden bg-slateink-100 sm:block" aria-hidden="true" data-id="element-295" data-mp="of5zc8xdafox" />}

        {next ? <Link to={next.to} className="group flex items-center justify-end gap-4 bg-slateink-100 px-6 py-8 text-right transition-colors hover:bg-white lg:px-8" data-id="element-296" data-mp="ag68cumdtopl">
            <span data-id="element-297" data-mp="24t5wxd8qpt90">
              <span className="block text-[10px] uppercase tracking-widest text-slateink-500" data-id="element-298" data-mp="24uqs952vpg7x">
                Next · Section {next.index}
              </span>
              <span className="mt-1.5 block font-serif text-base text-navy-900" data-id="element-299" data-mp="3hs7rbmznu5lj">
                {next.label}
              </span>
            </span>
            <ArrowRightIcon className="h-4 w-4 flex-none text-gold-600 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-300" data-mp="3csd1znvj9o2l" />
          </Link> : null}
      </div>
    </nav>;
}